// This function maps role names to their corresponding permission IDs
export const getPermissionIdForRole = (roleName, permissions) => {
  // Normalize the role name for comparison
  const normalizedRoleName = roleName.toLowerCase().trim();
  
  // Find the permission object based on the role name
  let permissionName = 'No Access'; // Default permission
  
  if (normalizedRoleName.includes('ceo') || 
      normalizedRoleName.includes('software engineer') || 
      normalizedRoleName.includes('software designer') || 
      normalizedRoleName.includes('it support') || 
      normalizedRoleName.includes('project manager') || 
      normalizedRoleName.includes('students') || 
      normalizedRoleName.includes('interns') || 
      normalizedRoleName.includes('pharmacy assistant') || 
      normalizedRoleName.includes('administration corporate pharmacy')) {
    permissionName = 'Limited Access';
  } else if (normalizedRoleName.includes('pharmacist') || 
             normalizedRoleName.includes('administration & pharmacist')) {
    permissionName = 'Full Access';
  } else {
    permissionName = 'No Access';
  }
  
  // Find the permission ID from the permissions array
  const permission = permissions.find(p => p.permission.toLowerCase() === permissionName.toLowerCase());
  return permission ? permission.permission : null;
};

